import React from 'react';
import FormattedDate from './FormattedDate';
import EditableName from './EditableName';

interface UserDetailsProps {
  user: {
    id: string;
    email: string;
    user_role: string;
    first_name: string;
    last_name: string;
    created_at: string;
    updated_at: string;
  };
  onSaveName?: (firstName: string, lastName: string) => Promise<void>;
  showId?: boolean;
  className?: string;
}

const UserDetails: React.FC<UserDetailsProps> = ({ user, onSaveName, showId = false, className = '' }) => {
  return (
    <div className={`border border-[color:var(--wf-border)] bg-[rgba(255,255,255,0.18)] p-6 ${className}`}>
      <div className="border-b border-[color:var(--wf-border)] pb-5">
        {onSaveName ? (
          <EditableName firstName={user.first_name} lastName={user.last_name} onSave={onSaveName} />
        ) : (
          <span className="font-serif text-2xl text-[color:var(--wf-ink)]">{user.first_name} {user.last_name}</span>
        )}
      </div>

      <dl className="mt-6 grid gap-x-6 gap-y-4 sm:grid-cols-[auto_1fr]">
        <dt className="text-xs uppercase tracking-[0.18em] text-[color:var(--wf-brass)]">Email</dt>
        <dd className="text-[color:var(--wf-ink)]">{user.email}</dd>

        <dt className="text-xs uppercase tracking-[0.18em] text-[color:var(--wf-brass)]">Role</dt>
        <dd className="text-[color:var(--wf-ink)]">{user.user_role}</dd>

        <dt className="text-xs uppercase tracking-[0.18em] text-[color:var(--wf-brass)]">Created</dt>
        <dd className="text-[color:var(--wf-ink)]"><FormattedDate date={user.created_at} /></dd>

        <dt className="text-xs uppercase tracking-[0.18em] text-[color:var(--wf-brass)]">Updated</dt>
        <dd className="text-[color:var(--wf-ink)]"><FormattedDate date={user.updated_at} /></dd>

        {showId && (
          <>
            <dt className="text-xs uppercase tracking-[0.18em] text-[color:var(--wf-brass)]">User ID</dt>
            <dd className="break-all font-mono text-sm text-[color:var(--wf-ink)]">{user.id}</dd>
          </>
        )}
      </dl>
    </div>
  );
};

export default UserDetails;
